import { useEffect, useRef } from 'react';
import type { RunnerDispatchPolicy } from '../lib/api';

/**
 * 정책 프리셋의 기본값(플랜 모드 + 주입 컨벤션)을 선택 직후 모달 상태에 1회 반영한다. 이후
 * 사용자가 값을 바꾸면 같은 정책(프리셋 버전 포함) 선택을 유지하는 한 다시 덮어쓰지 않아
 * 요청별 최종 선택권을 보장한다. 모달이 닫히거나 정책 선택이 해제되면 적용 기록을 리셋해
 * 다음 선택에 다시 반영되도록 한다.
 *
 * 컨벤션까지 함께 반영하는 이유: 정책 선택 시 planMode만 동기화하면 컨벤션 선택기가 비어
 * 보여 "정책이 주입할 컨벤션"을 사용자가 확인할 수 없다. 서버는 dispatchPolicy로 프리셋의
 * userConventionIds를 재해석하므로, 모달 표시를 그 진실과 일치시킨다.
 */
export const useDispatchPolicySelectionSync = (
  isOpen: boolean,
  selectedDispatchPolicy: RunnerDispatchPolicy | null,
  onDaemonPlanModeChange: (checked: boolean) => void,
  onUserConventionIdsChange: (ids: string[]) => void,
) => {
  const appliedDispatchPolicyKeyRef = useRef<string | null>(null);
  useEffect(() => {
    if (!isOpen || !selectedDispatchPolicy) {
      appliedDispatchPolicyKeyRef.current = null;
      return;
    }

    const policyKey = `${selectedDispatchPolicy.id}:${selectedDispatchPolicy.promptPreset.updatedAt}`;
    if (appliedDispatchPolicyKeyRef.current === policyKey) return;

    appliedDispatchPolicyKeyRef.current = policyKey;
    onDaemonPlanModeChange(selectedDispatchPolicy.promptPreset.planMode);
    onUserConventionIdsChange(selectedDispatchPolicy.promptPreset.userConventionIds);
  }, [isOpen, selectedDispatchPolicy, onDaemonPlanModeChange, onUserConventionIdsChange]);
};
